import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "my-page" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "order-list" }
const _hoisted_4 = { class: "order-type" }
const _hoisted_5 = { class: "order-status" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "asset-list" }
const _hoisted_8 = { class: "asset-name" }
const _hoisted_9 = { class: "asset-value" }
const _hoisted_10 = { class: "section" }
const _hoisted_11 = { class: "record-list" }
const _hoisted_12 = { class: "record-title" }
const _hoisted_13 = { class: "record-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"user-card\" data-v-4a19fab7><div class=\"avatar\" data-v-4a19fab7><img src=\"https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1107.jpg\" alt=\"头像\" data-v-4a19fab7></div><div class=\"user-info\" data-v-4a19fab7><h2 class=\"nickname\" data-v-4a19fab7>共富能手</h2><p class=\"phone\" data-v-4a19fab7>手机号：138****8888</p></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", null, "我的订单", -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
          return (_openBlock(), _createElementBlock("li", {
            key: order.id,
            class: "order-item"
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(order.type) + "：" + _toDisplayString(order.name), 1),
            _createElementVNode("span", _hoisted_5, "状态：" + _toDisplayString(order.status), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", null, "我的资产", -1)),
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (asset) => {
          return (_openBlock(), _createElementBlock("li", {
            key: asset.id,
            class: "asset-item"
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(asset.type) + "：" + _toDisplayString(asset.name), 1),
            _createElementVNode("span", _hoisted_9, "产权号：" + _toDisplayString(asset.propertyId), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", null, "我的浏览记录", -1)),
      _createElementVNode("ul", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record) => {
          return (_openBlock(), _createElementBlock("li", {
            key: record.id,
            class: "record-item"
          }, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(record.type) + "：" + _toDisplayString(record.name), 1),
            _createElementVNode("span", _hoisted_13, "时间：" + _toDisplayString(record.time), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}